<ts-dialog [title]="'How would you like to save the layout?'" (closeDialog)="matDialogRef.close()">
  <form [formGroup]="form" ts-dialog-body>
    <mat-radio-group formControlName="saveMode" color="primary">
      <mat-radio-button value="update" class="mb-2 flex flex-col">
        Update existing layout <span class="font-medium">{{ data.templateName }}</span
        >. This will apply to other {{ data.typeLabel }} using this layout.
      </mat-radio-button>
      <mat-radio-button value="create" class="mb-4">
        Create a new layout and apply to this <span class="font-medium">{{ data.typeLabel }}</span
        >.
      </mat-radio-button>
    </mat-radio-group>
    <mat-form-field [@slideInOut]="isCreateSaveMode ? 'in' : 'out'">
      <mat-label>What should we call this new template?</mat-label>
      <input matInput placeholder="Template Name" formControlName="templateName" />
    </mat-form-field>
  </form>
  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="matDialogRef.close()">Cancel</ts-button>
    <ts-button variant="primary" (click)="save()" [disabled]="isCreateSaveMode && !templateNameControl.value"
      >Save</ts-button
    >
  </div>
</ts-dialog>
